// extracted by mini-css-extract-plugin
export default {"Ribbon":"Ribbon_Ribbon__faNkp","RibbonHot":"Ribbon_RibbonHot__qVoki","RibbonSale":"Ribbon_RibbonSale__3Gb78"};